<template>
  <v-container fluid class="policy-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-policy`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Policy
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-playdetail-check</v-icon>
            Details
          </v-tab>
          <v-tab-item
            :value="'tab-policy'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Policy</p>
                      <v-menu
                        ref="menu_policydate"
                        v-model="menu_policydate"
                        :close-on-content-click="false"
                        :return-value.sync="policydate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="policydate"
                            label="Policy Date"
                            v-bind="attrs"
                            v-bind:value="policydate"
                            v-on:change="
                              updateChangedValue($event, 'policydate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the policy date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="policydate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_policydate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="updateChangedValue(policydate,'policydate');$refs.menu_policydate.save(policydate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'policycode')"
                        v-bind:value="initvalue.policycode"
                        placeholder="Policy Code"
                        persistent-hint
                        single-line hint="Enter the policy code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'policyname')"
                        v-bind:value="initvalue.policyname"
                        placeholder="Policy Name"
                        persistent-hint
                        single-line hint="Enter the policy name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=policytype
                        :value="initvalue.policytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'policytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the policy type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'policystatus')"
                          v-bind:label="initvalue.policystatus"
                          v-model="initvalue.policystatus"
                          value="Active"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/policy/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPolicy()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Policy Details</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showListDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="detailHeaders"
                        :items="policydetails"
                        :items-per-page="100"
                        sort-by="detailrank"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteListDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this List? </v-card-title>
                              <v-card-text>
                                {{ deletedetail.detailheading }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteListDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePolicyDetail(deletedetail)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.detailheading="{ item }">
                          <p v-if="item" class="two-line"><b>{{ item.detailheading }}</b></p>
                          <div class="two-line" v-html="item.detailtext"></div>
                        </template>                   
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editPolicyDetailSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePolicyDetailDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/policy/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="showListDialog"
      persistent
      width="800px"
      height="600px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Policy Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="detail.detailheading"
                  label="Title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor
                  v-model="detail.detailtext"
                 ></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showListDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPolicyDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showImageDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="image.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="image.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input outlined dense label="File input" v-on:change="onImageFileChange" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  outlined
                  dense
                  v-model="image.imageinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showImageDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPolicyImage"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
      <v-dialog
        v-model="showListSheet"
        persistent
        width="800px"
        height="600px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Policy Detail</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="1">
                  <v-text-field
                    v-on:change="updateChangedList($event, 'detailrank')"
                    :value="editdetail.detailrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="11">
                  <v-text-field
                    v-on:change="updateChangedList($event, 'detailheading')"
                    v-model="editdetail.detailheading"
                    label="Text"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <vue-editor
                    v-model="editdetail.detailtext"
                    @text-change="updateChangedList(editdetail.detailtext, 'detailtext')"
                    :value="editdetail.detailtext"
                  ></vue-editor>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="showListSheet = !showListSheet"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editPolicyDetail()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-bottom-sheet scrollable v-model="showImageSheet" inset>
        <v-sheet class="text-center" height="350px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showImageSheet = !showImageSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagerank')"
                  :value="editimage.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagename')"
                  :value="editimage.imagename"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-file-input outlined dense label="File input" v-model="imagefile" v-on:change="onImageFileChange" accept="image/*" />     
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                dense
                v-on:change="updateChangedImage($event, 'imageinfo')"
                :value="editimage.imageinfo"
                label="Info"
                required
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editPolicyImage()"
          >
            Edit
          </v-btn>
              </v-col>
           </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
  </v-row>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";
import {mapActions, mapState} from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from '@/Routes';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      imageHeaders: [
        { text: "#", value: "imagerank", width: "10px" },
        { text: "Image", value: "imageurl", width: "10%"},
        { text: "Name", value: "imagename" , width: "65%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      detailHeaders: [
        { text: "#", value: "detailrank", width: "10px" },
        { text: "Text", value: "detailheading" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      policy: {},
      policydetails: [],
      policyimages: [],
      initvalue: {},
      policytype: ['Welcome', 'Employment', 'Workplace Behavior', 'Recruitment', 'Health & Safety', 'Leave', 'Benefits', 'Performance', 'Employee Separation', 'Training & Development', 'Business Travel', 'Administration'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      detail: {},
      editdetail: {},
      deletedetail: {},
      deleteListDialog: false,
      showListDialog: false,
      showListSheet: false,
      image: {},
      imagefile: null,
      editimage: {},
      deleteimage: {},
      deleteImageDialog: false,
      showImageDialog: false,
      showImageSheet: false,
      menu_policydate: false,
      policydate: null,
    }
  },
  methods: {
    ...mapActions('Policy', [
      'getPoliciesRequest',
      'deletePolicyImageRequest', 'deletePolicyDetailRequest',
      'insertPolicyDetailRequest', 'insertPolicyImageRequest',
      'updatePolicyRequest','updatePolicyImageRequest','updatePolicyDetailRequest',
    ]),
    async addPolicyDetail() {
      this.showListDialog = false;
      this.detail.policyid = this.initvalue._id;
      let result = await this.insertPolicyDetailRequest(this.detail);
      this.policydetails.push(result);
      this.detail = {};
    },
    async addPolicyImage() {
      this.showImageDialog = false;
      this.image.policyid = this.initvalue._id;
      let result = await this.insertPolicyImageRequest(this.image);
      this.policyimages.push(result);
      this.image = {};
    },
    deletePolicyDetailDialog(item) {
      this.deleteListDialog = true;
      this.deletedetail = {
        _id: item._id,
        detailheading: item.detailheading,
      };
    },
    deletePolicyImageDialog(item) {
      this.deleteImageDialog = true;
      this.deleteimage = {
        _id: item._id,
        imagename: item.imagename,
      };
    },
    async deletePolicyDetail(payload) {
      this.deleteListDialog = false;
      let response = await this.deletePolicyDetailRequest(payload);
      let index = this.policydetails.findIndex((trans) => trans._id == response._id);
      this.policydetails.splice(index, 1);
    },
    async deletePolicyImage(payload) {
      this.deleteImageDialog = false;
      let response = await this.deletePolicyImageRequest(payload);
      let index = this.policyimages.findIndex((trans) => trans._id == response._id);
      this.policyimages.splice(index, 1);
    },
    editPolicy() {
      this.policy._id = this.initvalue._id;
      this.updatePolicyRequest(this.policy);
      this.getPoliciesRequest();
      router.push('/policy/list');
    },
    async editPolicyDetail() {
      this.showListSheet = false;
      this.detail.policydetailid = this.editdetail._id;
      let response = await this.updatePolicyDetailRequest(this.detail);
      let index = this.policydetails.findIndex((x) => x._id == response._id);
      this.policydetails.splice(index, 1, response);
    },
    editPolicyDetailSheet(item) {
      this.detail = {};
      this.showListSheet = true;
      this.editdetail = Object.assign({}, item);
    },
    editPolicyImageSheet(item) {
      this.image = {};
      this.showImageSheet = true;
      this.editimage = Object.assign({}, item);
    },
    async editPolicyImage() {
      this.showImageSheet = false;
      this.imagefile = null;
      this.image.policyimageid = this.editimage._id;
      let response = await this.updatePolicyImageRequest(this.image);
      let index = this.policyimages.findIndex((x) => x._id == response._id);
      this.policyimages.splice(index, 1, response);
    },
    onImageFileChange(file) {
      if (!file) {return;}
      this.image.imagefile = file;
      this.image.imagefilename = file.name;
    },
    updateChangedValue(value, field){
      this.policy[field] = value;
    },
    updateChangedImage(value, field){
      this.image[field] = value;
    }, 
    updateChangedList(value, field){
      this.detail[field] = value;
    },    
  },
  computed: {
    ...mapState('Policy', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.policydetails = this.initvalue.details;
    this.policyimages = this.initvalue.policyimages;
    this.policydate = formatStdDate(this.initvalue.policydate);
    if(!this.initvalue._id) this.$router.push({ name: 'PolicyList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
